import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './app/views/theme/base/base.component';
import { AppRouteGuard } from './shared/auth/auth-route-guard';
import { LoginComponent } from './app/views/pages/transpop/login/login.component';
import { AppPublicComponent } from './app-public/app-public.component';

const routes: Routes = [
   
    {
        path:'public',
        component: AppPublicComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./app-public/app-public.module').then(m => m.AppPublicModule), // Lazy load account module
                data: { preload: true }
            }
        ]
    },
    {
        path: 'login',
        component : LoginComponent,
        canActivate:[AppRouteGuard]
        //loadChildren: () => import('./app/views/pages/transpop/login/login.module').then(m => m.LoginModule), 
    },
    {
        path: '',
        component : BaseComponent,
        canActivate : [AppRouteGuard],
        children : [ 
           // { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
            {
                path: 'app',
                loadChildren: () => import('./app/app.module').then(m => m.AppModule), // Lazy load account module
                data: { preload: true }
            },
            {
                path: 'platom',
                loadChildren: () => import('./app/views/pages/platom/platom.module').then(m => m.PlatomModule), // Lazy load account module
                data: { preload: true }
            },
            {
                path: 'test',
                loadChildren: () => import('./test/test.module').then(m => m.TestModule), // Lazy load account module
                data: { preload: true }
            },

           
           
            
        ]
        
    },
    
    
   
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],


exports: [RouterModule],
    providers: []
})
export class RootRoutingModule { }
